import React from "react";
import { inject, observer } from "mobx-react";
import { ProposalStore } from "../../../stores/proposalStore";
import { CalculateStore } from "../../../stores/calculateStore";
import Header from "../../sharedComponents/header/header";
import Plot from "./plot";
import TextInput from "../../sharedComponents/textInput/textInput";
import { ValidatedValue } from "../../../helpers/validator";
import NumberInput from "../../sharedComponents/numberInput/numberInput";
import Year from "./year";


interface GravestoneProps {
  proposalStore?: ProposalStore;
  calculateStore?: CalculateStore;
}

@inject("proposalStore", "calculateStore")
@observer
export default class Gravestone extends React.Component<GravestoneProps> {
  public render() {
    return (
      <>
        {this.isGravestoneInsured() && (
          <div className="gravestone">
            {this.renderGravestone()}
          </div>
        )}
      </>
    );
  }

  private isGravestoneInsured(): boolean {
    return this.props.calculateStore!.additionalInsurances.gravestone.checked;
  }

  private renderGravestone() {
    const gravestone = this.props.proposalStore!.gravestone;

    return (
      <div className="section gravestone">
        <Header type="medium" mainHeader={"Adres ubezpieczonego nagrobka cmentarnego (adres cmentarza)"} />
        {this.renderTextInput("Nazwa cmentarza", gravestone.cemeteryName)}
        {this.renderTextInput("Adres cmentarza", gravestone.cemeteryAddress)}
        <Year year={gravestone.year} />
        {this.renderTextInput("Kwatera", gravestone.sector)}
        {this.renderTextInput("Rząd", gravestone.row)}
        <Plot gravestone={gravestone} />
      </div>
    );
  }

  private renderTextInput(label: string, value: ValidatedValue<string>) {
    return (
      <div className="field-container">
        <div className="label">{label}</div>
        <TextInput
          validatedValue={value}
          topLabel={label}
        />
      </div>);
  }

  private renderNumberInput(label: string, value: ValidatedValue<number>, maxLength: number) {
    return (
      <div className="field-container">
        <div className="label">{label}</div>
        <NumberInput
          validatedValue={value}
          topLabel={label}
          maxLength={maxLength}
        />
      </div>);
  }
}
